module.exports = __webpack_public_path__ + "static/media/save.50e17428.svg";